import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { PublishedApp } from '@/features/apps/shared/models';

export interface AppState {
	workspaces: WorkspaceViewModel[];
	currentWorkspace: WorkspaceViewModel;
	currentApp: PublishedApp | null;
	installedApps: string[];
	error: string;
}

// initial state
export const appState: AppState = {
	workspaces: [],
	currentWorkspace: {
		id: '',
		name: '',
		features: {},
		usageLimits: {}
	},
	currentApp: null,
	installedApps: [],
	error: ''
};

export const app: Module<AppState, AppState> = {
	namespaced: false,
	state: appState,
	getters,
	actions,
	mutations
};
